import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Platform } from 'react-native';

import { BodyText } from '@garnish/core';
import { CustomNavigationHeader } from '@garnish/navigation';

export const ForgotToScanHeader = (props: ForgotToScanHeaderProps) => {
  const { goBack, onClose } = props;
  const { formatMessage } = useIntl();

  return (
    <CustomNavigationHeader.Container safeAreaEdges={safeAreaEdges}>
      {goBack ? (
        <CustomNavigationHeader.Button.Left
          name="IconArrowLeft"
          onPress={goBack}
          accessibilityLabel={formatMessage(messages.goBackButtonA11yLabel)}
        />
      ) : null}

      <BodyText sizeMatch={['16']}>{formatMessage(messages.title)}</BodyText>

      <CustomNavigationHeader.Button.Right
        name="IconClose"
        onPress={onClose}
        accessibilityLabel={formatMessage(messages.closeButtonA11yLabel)}
      />
    </CustomNavigationHeader.Container>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const safeAreaEdges = Platform.OS === 'android' ? ['top' as const] : [];

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Request Points',
    description: 'Forgot To Scan | Header | Title',
  },
  goBackButtonA11yLabel: {
    defaultMessage: 'Go back',
    description: 'Forgot To Scan | Header | Go back button | a11y label',
  },
  closeButtonA11yLabel: {
    defaultMessage: 'Close',
    description: 'Forgot To Scan | Header | Close button | a11y label',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ForgotToScanHeaderProps = {
  goBack?: () => void;
  onClose: () => void;
};
